import { Outlet } from "react-router-dom";
import React from "react";

const AuthenticationLayout = () => {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Outlet />
    </div>
  );
};

export default AuthenticationLayout;
